import { useState } from "react";
import { useStore, CAT_META } from "../store/Store";

// ─── BLOOM CARD ───────────────────────────────────────────────────────────────
// Soft pastel background with delicate floral corner accents (SVG petals) —
// romantic, feminine, tailored specifically for a ladies-clothing catalog.
// No hard edges or bold blocks, unlike the rest of the set.
export default function BloomCard({ p, onNav, accent }) {
  const { dispatch, wish, toggleWish, notify } = useStore();
  const [hovered, setHovered] = useState(false);
  const meta = CAT_META[p.category] || { emoji:"👗" };
  const disc = Math.round((1 - p.price / p.mrp) * 100);
  const wished = wish.includes(p.id);

  const addCart = (e) => {
    e.stopPropagation();
    dispatch({ type:"ADD", p:{ ...p, sc:p.colors?.[0]||"Default", ss:p.sizes?.[0]||"Free" } });
    notify(`${p.name} added!`);
    if (navigator.vibrate) navigator.vibrate(50);
  };

  return (
    <div
      onClick={()=>onNav("product", p.id)}
      onMouseEnter={()=>setHovered(true)}
      onMouseLeave={()=>setHovered(false)}
      style={{
        borderRadius:24, overflow:"hidden", cursor:"pointer", position:"relative",
        background:`${accent}0d`, border:`1px solid ${accent}25`,
        boxShadow: hovered ? `0 18px 36px ${accent}25` : "0 4px 14px rgba(0,0,0,0.04)",
        transform: hovered ? "translateY(-5px)" : "translateY(0)",
        transition:"all 0.35s ease",
      }}>
      {/* Corner petal accents */}
      <svg width="46" height="46" viewBox="0 0 46 46" style={{ position:"absolute", top:8, left:8, opacity:0.5, pointerEvents:"none" }}>
        <path d="M4 20 Q4 4 20 4 Q10 12 4 20Z" fill={accent}/>
        <path d="M4 20 Q4 4 20 4 Q12 10 4 20Z" fill={accent} opacity="0.6"/>
      </svg>
      <svg width="46" height="46" viewBox="0 0 46 46" style={{ position:"absolute", bottom:8, right:8, opacity:0.35, pointerEvents:"none", transform:"rotate(180deg)" }}>
        <path d="M4 20 Q4 4 20 4 Q10 12 4 20Z" fill={accent}/>
      </svg>

      <div style={{ padding:"18px 18px 0" }}>
        <div style={{ fontSize:9, fontWeight:700, letterSpacing:2, color:accent, textTransform:"uppercase", marginBottom:2 }}>✿ {p.category}</div>
      </div>

      <div style={{ height:225, margin:"6px 18px 0", borderRadius:16, overflow:"hidden", background:"white", position:"relative", display:"flex", alignItems:"center", justifyContent:"center" }}>
        {p.img
          ? <img src={p.img} alt={p.name} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"top", transition:"transform 0.5s ease", transform:hovered?"scale(1.05)":"scale(1)" }} loading="lazy"/>
          : <div style={{ fontSize:44, opacity:0.25 }}>{meta.emoji}</div>
        }
        {disc > 0 && (
          <span style={{ position:"absolute", top:8, right:8, background:"white", color:accent, fontSize:9, fontWeight:800, padding:"3px 9px", borderRadius:20, boxShadow:"0 2px 8px rgba(0,0,0,0.12)" }}>
            {disc}% OFF
          </span>
        )}
        <button onClick={e=>{ e.stopPropagation(); toggleWish(p.id); if(navigator.vibrate)navigator.vibrate(30); }}
          style={{ position:"absolute", top:8, left:8, background:"white", border:"none", borderRadius:"50%", width:26, height:26, fontSize:12, cursor:"pointer", boxShadow:"0 2px 8px rgba(0,0,0,0.12)" }}>
          {wished ? "❤️" : "🤍"}
        </button>
      </div>

      <div style={{ padding:"14px 18px 18px", textAlign:"center" }}>
        <div style={{ fontFamily:"'Playfair Display',serif", fontSize:14.5, fontWeight:700, color:"#1a1a2e", marginBottom:8, lineHeight:1.3 }}>{p.name}</div>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:10 }}>
          <span style={{ fontSize:15, fontWeight:900, color:"#1a1a2e" }}>₹{p.price?.toLocaleString("en-IN")}</span>
          {p.stock > 0 && (
            <button onClick={addCart} style={{ background:accent, color:"white", border:"none", padding:"6px 15px", borderRadius:20, fontSize:10, fontWeight:800, cursor:"pointer" }}>+ Add</button>
          )}
        </div>
      </div>
    </div>
  );
}
